import * as Yup from "yup";

export const academicProgramSchema = Yup.object().shape({
  name: Yup.string().required("Program name is required"),
  institution_id: Yup.string().required("Institution is required"),
  program_code: Yup.string().required("Program code is required"),
  academic_program_level_id: Yup.string().required("Program level is required"),
  duration: Yup.string().required("Duration is required"),
  status: Yup.string().required("Status is required"),
});
